import Component from 'gia/Component'
import Observer from '../components/observer';
import gsap from 'gsap'


class Heart extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
   // this.i = 0


    this.ref = {
      container: null,
      heart: null
      
    }

  }

  mount() {

   

    const heart = gsap.timeline({
      repeat: 1,
      repeatDelay: 0,
      paused: true
    })
    heart.to(this.ref.heart, {
      scaleX: 1.2,
      scaleY: 1.2,
      duration: .3,
      ease: 'elastic.in',
      transformOrigin: 'center'
    });
    heart.to(this.ref.heart, {
      scaleX: .3,
      scaleY: .3,
      duration: .3,
      ease: 'power4.in',
       transformOrigin: 'center'
    });
    heart.to(this.ref.heart, {
      scaleX: 1,
      scaleY: 1,
      duration: .7,
      ease: 'elastic.out',
       transformOrigin: 'center'
    });

   
this.observer = new Observer({
  rootMargin: '20% 0% -5% 0%',
  callback: (visible, target, entry) => {

    if (visible) {
      console.log(visible)
      heart.play()
    } else {
      heart.pause(0)
    }
  }
});
this.observer.add([this.ref.container]);
    }    



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Heart



